import { render, staticRenderFns } from "./InventoryItemFilter.vue?vue&type=template&id=df4aa9de"
import script from "./InventoryItemFilter.vue?vue&type=script&lang=js"
export * from "./InventoryItemFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports